<template>
    <aside class="sidebar" :class="{open: menu}">
        <nav class="sidebar__list">
            <router-link :to="{name:'main'}" class="sidebar__item" :class="{active: route.name === 'main'}">
                <icon-component class="sidebar__icon" name="home"/>
                <span>Главная страница</span>
            </router-link>
            <router-link :to="{name:'profile'}" class="sidebar__item" :class="{active: route.name === 'profile'}">
                <icon-component class="sidebar__icon" name="profile"/>
                <span>Мой профиль</span>
            </router-link>
            <router-link :to="{name:'ordersList'}" class="sidebar__item" :class="{active: route.name === 'orders'}">
                <icon-component class="sidebar__icon" name="paper"/>
                <span>Список заказов</span>
            </router-link>
            <router-link :to="{name:'users'}" class="sidebar__item" v-if="admin" :class="{active: route.name === 'users'}">
                <icon-component class="sidebar__icon" name="users"/>
                <span>Пользователи</span>
            </router-link>
            <router-link :to="{name:'settings'}" class="sidebar__item sidebar__item_mt" :class="{active: route.name === 'settings'}">
                <icon-component class="sidebar__icon" name="settings"/>
                <span>Настройки</span>
            </router-link>
            <router-link :to="{name:'ordersArchive'}" class="sidebar__item" v-if="admin">
                <icon-component class="sidebar__icon" name="basket"/>
                <span>Корзина</span>
            </router-link>
<!--            <a href="https://artgorka.ru/" class="sidebar__item sidebar__item_link">-->
<!--                <icon-component class="sidebar__icon" name="browser"/>-->
<!--                <span>Перейти на сайт</span>-->
<!--            </a>-->
        </nav>
    </aside>
</template>
<script setup lang="ts">
import { onMounted, ref} from 'vue';
import { useRoute } from 'vue-router';
import iconComponent from '../shared/iconComponent.vue';

const props = defineProps({
    menu: {
        type: Boolean,
        required: true,
    }
})
const route = useRoute()
const role = localStorage.getItem("role")
let admin = ref(false)

onMounted( () => {
    if(role) {
        if(role === "Администратор" || "Главный менеджер" || "Менеджер") {
            admin.value = true
        } else {
            admin.value = false
        }
    }
})
</script>